<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Safety Data Sheet :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-data-sheets`">
                            <i class="fa fa-life-ring"></i> Safety Data Sheet
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-data-sheets/view/${sheet.id}`">
                            {{ sheet.data_sheet_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-header">Delete Safety Data Sheet</div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this safety data sheet <strong>{{ sheet.data_sheet_name }}</strong>. This will delete all files revisions and the data sheet record. This cannot be undone.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteDataSheet()" :disabled="deleting">
                                <template v-if="!deleting">
                                    Delete Safety Data Sheet
                                </template>
                                <template v-else>
                                    Deleting...
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                sheet: {},
                errors: {},
            }
        },

        methods: {

            getSafetyDataSheet: function() {
                //Get the data
                this.$http
                    .get('/safety-data-sheets/edit/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.sheet = response.data.sheet;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            deleteDataSheet: function() {
                //SHow loading
                this.deleting = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('/safety-data-sheets/delete/' + this.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Safety Data Sheet Deleted');

                    //Return to main list?
                    this.$router.push('/safety-data-sheets');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },
        },

        mounted() {
            //Get the Safety Data Sheet
            this.getSafetyDataSheet();
        }
    }
</script>
